<template>
    <b-modal v-model="showModal" :title="title" centered size="md" footer-class="justify-content-between"
        content-class="bg-gray-50" @hidden="onHide" @shown="isModalShown = true">
        <div style="min-height: 300px">
            <ResourceFields v-if="isModalShown" :key="resource.id" ref="fields" :resource="resource"
                :is-editable="isEditable" @saved="onSaved" />
        </div>
        <template v-slot:modal-footer="{ cancel }">
            <template v-if="isPersisted">
                <div>
                    <b-button v-if="url" :href="url" variant="gray-primary">
                        View Details
                    </b-button>
                </div>
                <div>
                    <div v-if="isEditable" class="d-flex gap-2">
                        <b-button variant="gray-secondary" @click="onEditCancel">Cancel Edits</b-button>
                        <b-button variant="sharp-success" @click="onSave">Save Edits</b-button>
                    </div>
                    <div v-else class="d-flex gap-2">
                        <b-button variant="gray-secondary" @click="cancel">Cancel</b-button>
                        <b-button variant="gray-primary" @click="onEdit">Edit</b-button>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="d-flex w-100 justify-content-end gap-2">
                    <b-button variant="gray-secondary" @click="cancel">Cancel</b-button>
                    <b-button variant="primary" @click="onSave">
                        Save &amp; close
                    </b-button>
                </div>
            </template>
        </template>
    </b-modal>
</template>

<script>
import ResourceFields from "@/components/resources/ResourceFields";

export default {
    components: { ResourceFields },
    data: function () {
        return {
            showModal: false,
            isModalShown: false,
            isRedirect: false,
            resource: {},
            isEditable: false,
        };
    },
    computed: {
        isPersisted() {
            return !!this.resource?.id;
        },
        url() {
            return this.resource?.url;
        },
        title() {
            return this.isPersisted
                ? `${this.resource.type} Details`
                : `New ${this.resource.type}`;
        },
    },
    methods: {
        new(resource) {
            this.resource = Object.assign(
                {
                    type: "Vendor",
                },
                resource
            );

            this.showModal = true;
        },
        show(resource) {
            // TODO: resource.type should be part of object already
            // this modal is used for a Vendor only right now
            this.resource = Object.assign(
                {
                    type: "Vendor",
                },
                resource
            );

            this.showModal = true;
        },
        edit(resource) {
            this.show(resource);
            this.onEdit();
        },
        onHide() {
            this.isEditable = false;
            this.isRedirect = false;
            this.isModalShown = false;
            this.resource = {};
        },
        onEdit() {
            this.isEditable = true;
        },
        onEditCancel() {
            this.isEditable = false;
            this.$refs.fields.reset(this.resource);
        },
        onSave(params = {}) {
            this.isRedirect = params.isRedirect;
            this.$refs.fields.save();
        },
        onSaved(resource) {
            this.$emit("saved", resource);

            this.showModal = false

            if (this.url && this.isRedirect) {
                this.$toast.success('Redirecting...')
                window.location.href = this.url;
            }
        },
    },
};
</script>
